<template>
    <el-drawer title="角色管理" v-model="view" size="50%" :before-close="closeView">
        <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
            <div class="TTL-input width250">
            <el-input v-model="roleparam.key" placeholder="角色名称" clearable @keydown.enter.prevent="GetManagerRole" @change="[roleparam.ischange=true]" />
            </div>
            </el-form-item>
            <el-form-item>
            <div class="TTL-button">
            <el-button @click="GetManagerRole">搜索</el-button>
            <el-button @click="AddRole">新增角色</el-button>
            </div> 
            </el-form-item>
        </el-form>
        </div>
        <div class="TTL-el-drawer-content">
            <div class="TTL-table top20" id="table-managerrole-obj">
            <el-table :data="rolelist" stripe="true" empty-text="" ref="pet">
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column prop="rolename" label="角色名称" align="center" min-width="140" />
                <el-table-column prop="managercounts" label="拥有管理员" align="center" min-width="140" />
                <el-table-column prop="inputtime" label="添加时间" align="center" min-width="140" />
                <el-table-column label="操作" align="center" min-width="300">
                    <template #default="scope">
                    <div class="TTL-button">
                    <el-button @click="EditManager(scope.row)" v-if="scope.row.shopid > 0">编辑</el-button>
                    <el-button type="del" @click="DelManager(scope.row.id)" v-if="scope.row.shopid > 0">删除</el-button>
                    <el-button @click="SetAuto(scope.row.id)" v-if="scope.row.shopid > 0">设置权限</el-button>
                    </div>
                    </template>
                </el-table-column>
            </el-table>
            </div>
        </div>
        <div class="TTL-page-box top20">
            <div class="TTL-page-box-in">
                <div class="TTL-page TTL-page-right">
                    <el-pagination
                        @current-change="changepage"
                        @size-change="changesize"
                        v-model:current-page="roleparam.p"
                        v-model:page-size="roleparam.rollpage"
                        :page-sizes="[20,40,60,100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="roleparam.rows"
                    />
                </div>
            </div>
        </div>
    </el-drawer>

    <!-- 新增角色 -->
    <ManagerAddOrEdit :value="addViewparam.view" :id="addViewparam.id" :rolename="addViewparam.name" @AddOrEditRollback="AddOrEditRollback" />

    <!-- 权限设置 -->
    <ManagerAuth :value="authViewparam.view" :id="authViewparam.id" @AuthRollback="AuthRollback" />


</template>

<script>
import INTERFACE_MODEL_MANAGER from '@/Interface/manager/manager';
import ManagerAddOrEdit from '@/views/Manager/ManagerAddOrEdit';  //新增、编辑角色
import ManagerAuth from '@/views/Manager/ManagerAuth';            //权限设置
export default {
    props:['value'],
    components:{ManagerAddOrEdit,ManagerAuth},
    data() {
        return {
            view:false,
            roleparam: {
                ischange:false,
                key:'',
                p:1,
                rollpage:10,
                rows:0
            },
            rolelist:[],
            addViewparam: {
                view:false,
                id:'',
                name:''
            },
            authViewparam: {
                view:false,
                id:''
            },

        }
    },
    mounted() {
        
    },
    watch: {
        value(val) {
            if(!val) return false;
            var _this=this;
            this.view=true;
            this.resetparam();     //搜索参数重置
            setTimeout(function() {
                _this.GetManagerRole(); //获取数据搜索
            },200);
        }
    },
    methods: {
        
        /** 新增角色 **/
        AddRole() {
            this.addViewparam.view=true;
            this.addViewparam.id='';
            this.addViewparam.name='';
        },

        /** 编辑角色 **/
        EditManager(item) {
            console.log(item);
            this.addViewparam.view=true;
            this.addViewparam.id=item.id;
            this.addViewparam.name=item.rolename;
        },

        /** 新增/编辑角色信息回调 **/
        AddOrEditRollback() {
            this.addViewparam.view=false;
            this.GetManagerRole();
        },

        /** 设置权限 **/
        SetAuto(id) {
            this.authViewparam.view=true;
            this.authViewparam.id=id;
        },

        /** 设置权限回调 **/
        AuthRollback() {
            this.authViewparam.view=false;
            this.GetManagerRole();
        },
        
        /** 删除角色 **/
        DelManager(id) {
            INTERFACE_MODEL_MANAGER.DEL_MANAGER_ROLE({id:id}).then((res) => {
                if(res.status > 0) return false;
                this.GetManagerRole();
            });
        },

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        //基础操作

        /** 角色信息搜索 **/
        GetManagerRole() {
            if(this.roleparam.ischange) {
                this.roleparam.ischange=false;
                this.roleparam.p=1;
                this.roleparam.rollpage=10;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-managerrole-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MANAGER.GET_MANAGER_ROLE(this.roleparam).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.roleparam.rows=res.data.count;
                 this.rolelist=res.data.list;
            });
        },

        /** 修改当前页数 **/
        changepage(p) {
            this.roleparam.p=p;
            this.GetManagerRole();
        },

        changesize(rollpage) {
            this.roleparam.rollpage=rollpage;
            this.GetManagerRole();
        },


        /** 搜索参数重置 **/
        resetparam() {
            this.roleparam.ischange=false;
            this.roleparam.key='';
            this.roleparam.p=1;
            this.roleparam.rollpage=10;
            this.roleparam.rows=0;
        },

        /** 关闭窗口前执行操作 **/
        closeView() {
            this.view=false;
            this.RollBackParent();
        },

        /** 回调函数执行处理 **/
        RollBackParent() {
            this.$emit('rollback');
        },

        //基础操作
        ////////////////////////////////////////////
        ////////////////////////////////////////////

    },
}
</script>
<style scoped>

</style>